import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";

export interface OrderStatusProps {
  status: string;
  onClick?: React.MouseEventHandler<HTMLTableHeaderCellElement> &
    React.MouseEventHandler<HTMLTableDataCellElement>;
}

const useStyles = makeStyles(
  () => {
    const dot = {
      borderRadius: "100%",
      content: "''",
      display: "block",
      height: "12px",
      marginLeft: "9px",
      marginTop: "5px",
      position: "absolute" as "absolute",
      width: "12px"
    };

    return {
      cancelledDot: {
        "&:before": { backgroundColor: "#9C9C9C", ...dot }
      },
      completedDot: {
        "&:before": { backgroundColor: "#7CAC75", ...dot }
      },
      defaultDot: {
        "&:before": { backgroundColor: "#74A5E7", ...dot }
      },
      newDot: {
        "&:before": { backgroundColor: "#C8B899", ...dot }
      },
      orderStatuslabel: {
        fontWeight: 600,
        marginLeft: "25px",
        overflow: "hidden",
        paddingRight: "11px",
        textOverflow: "ellipsis"
      },
      returnedToFcDot: {
        "&:before": { backgroundColor: "#FFD15C", ...dot }
      },
      stateReturnedToFc: {
        backgroundColor: "#FFF6DE"
      },
      statusCancelled: {
        backgroundColor: "#D9D9D9"
      },
      statusCompleted: {
        backgroundColor: "#A4EA9A"
      },
      statusDefaultLabel: {
        backgroundColor: "#C6DDFF"
      },
      statusNewLabel: {
        backgroundColor: "#FFEBC6"
      },
      statusWrapper: {
        borderRadius: "25px",
        display: "inline",
        margin: "2px",
        paddingBottom: "5px",
        paddingTop: "5px",
        position: "relative",
        whiteSpace: "nowrap"
      }
    };
  },
  { name: "OrderStatusCell" }
);

const OrderStatus: React.SFC<OrderStatusProps> = ({ status, onClick }) => {
  const classes = useStyles({});

  let newLabel = "";
  switch (status) {
    case "NEW_ORDER":
      newLabel = "New Order";
      break;
    case "ACKNOWLEDGED":
      newLabel = "Acknowledged";
      break;
    case "CANCELED":
      newLabel = "Cancelled";
      break;
    case "COLLECTED":
      newLabel = "Collected";
      break;
    case "COMPLETED":
      newLabel = "Completed";
      break;
    case "PACKED":
      newLabel = "Packed";
      break;
    case "READY":
      newLabel = "Ready";
      break;
    case "READY_TO_SHIP":
      newLabel = "Ready to Ship";
      break;
    case "RECEIVED_AT_FC":
      newLabel = "Received at FC";
      break;
    case "RETURN_TO_FC":
      newLabel = "Returned to FC";
      break;
    case "SHIPPED":
      newLabel = "Shipped";
      break;
    default:
      break;
  }

  const checkStatus = () => {
    switch (status) {
      case "NEW_ORDER":
        return (
          <div
            className={classNames(
              classes.statusNewLabel,
              classes.statusWrapper
            )}
            id={`orderDropdown${newLabel.replace(/\s+/g, "")}Status`}
          >
            <span
              className={`${classes.statusNewLabel} ${classes.newDot}`}
            ></span>
            <span className={classes.orderStatuslabel}>{newLabel}</span>
          </div>
        );
      case "COMPLETED":
        return (
          <div
            className={classNames(
              classes.statusCompleted,
              classes.statusWrapper
            )}
            id={`orderDropdown${newLabel.replace(/\s+/g, "")}Status`}
          >
            <span
              className={`${classes.statusCompleted} ${classes.completedDot}`}
            ></span>
            <span className={classes.orderStatuslabel}>{newLabel}</span>
          </div>
        );
      case "CANCELED":
        return (
          <div
            className={classNames(
              classes.statusCancelled,
              classes.statusWrapper
            )}
            id={`orderDropdown${newLabel.replace(/\s+/g, "")}Status`}
          >
            <span
              className={`${classes.statusCancelled} ${classes.cancelledDot}`}
            ></span>
            <span className={classes.orderStatuslabel}>{newLabel}</span>
          </div>
        );
      case "RETURN_TO_FC":
        return (
          <div
            className={classNames(
              classes.stateReturnedToFc,
              classes.statusWrapper
            )}
            id={`orderDropdown${newLabel.replace(/\s+/g, "")}Status`}
          >
            <span
              className={`${classes.stateReturnedToFc} ${classes.returnedToFcDot}`}
            ></span>
            <span className={classes.orderStatuslabel}>{newLabel}</span>
          </div>
        );
      default:
        return (
          <div
            className={classNames(
              classes.statusDefaultLabel,
              classes.statusWrapper
            )}
            id={`orderDropdown${newLabel.replace(/\s+/g, "")}Status`}
          >
            <span
              className={`${classes.statusDefaultLabel} ${classes.defaultDot}`}
            ></span>
            <span className={classes.orderStatuslabel}>{newLabel}</span>
          </div>
        );
    }
  };

  return <div onClick={onClick}>{checkStatus()}</div>;
};

export default OrderStatus;
